import React from 'react';
import './Popup.css';
import ParticlesBackground from './ParticlesBackground';

export default function Slider() {

    return (
        <div id="slider">
            <ParticlesBackground />
            <div id="slidertext">
                <h3 style={{
                    fontSize: '24px',
                    fontWeight: '500',
                    letterSpacing: '2px',
                    marginBottom: '20px',
                    color: '#25D366',
                    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)'
                }}>اشعر وكأنك في منزلك</h3>
                <br />
                <h1 style={{
                    fontSize: '56px',
                    fontWeight: '800',
                    marginBottom: '30px',
                    textShadow: '3px 3px 6px rgba(0, 0, 0, 0.4)',
                    letterSpacing: '1px'
                }}>مظهر رائع مضمون</h1><br />
                <p style={{
                    fontSize: '18px',
                    lineHeight: '1.8',
                    maxWidth: '600px',
                    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
                    marginBottom: '30px'
                }}>مركز بالي طلاسو للعناية بالرجال يقدم خدمات متميزة تشمل المساج ،الحمام المغربي ، و البديكير ، مما يضمن لعملائه تجربة فاخرة ومريحة تساعدهم على الاسترخاء وتنظيف البشرة وتجديد النشاط</p><br />
            </div>
            <div id="sliderimg"></div>
        </div>
    );
}
